import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = "Page Not Found | FCBracket";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "The page you're looking for doesn't exist.");
  }, []);

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex flex-col items-center justify-center px-4 pt-32 pb-20 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <p className="font-display text-[8rem] md:text-[10rem] leading-none text-primary/20 select-none">
            404
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          className="space-y-3 -mt-4"
        >
          <h1 className="font-display text-3xl md:text-4xl text-foreground">
            Offside!
          </h1>
          <p className="font-body text-muted-foreground max-w-md mx-auto">
            Looks like this page doesn't exist. It may have been moved or you followed a broken link.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center gap-3 mt-8"
        >
          <Link to="/">
            <Button className="font-display gap-2">
              <Home className="w-4 h-4" /> Back to Home
            </Button>
          </Link>
          <Button variant="outline" className="font-display gap-2" onClick={() => window.history.back()}>
            <ArrowLeft className="w-4 h-4" /> Go Back
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
